import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import React from 'react'
import { H3 } from '../Heading/index'
import { getBoundActions } from '../../actions/index'
import { TYPE_CONTENT_COURSE } from '../../services/content-type/index'
import { CLICK_TO_DETAILS_PAGE_GA4_EVENT } from '../../services/event-tracking/index'
import Link from '../Link/index'

const TitleCourseVideo = (props) => {
  const {
    linkClass = '',
    titleClass = '',
    hasHeader,
    video,
    primaryCourse,
  } = props

  const courseTitle = primaryCourse.get('title')
  const coursePath = primaryCourse.get('path')

  const courseDetailsEventData = primaryCourse && primaryCourse.size > 0
    ? CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep({
      content_id: primaryCourse.get('contentId'),
      content_name: courseTitle,
      content_type: TYPE_CONTENT_COURSE,
      media_language: video.getIn(['data', 'feature', 'id']),
      is_featured_media: true,
      ui_location: hasHeader ? 'Video Player' : 'End Screen',
      ui_element: 'Title',
    })
    : null

  return (
    <Link
      to={coursePath}
      className={`video-series-title__link-container ${linkClass}`}
      ga4EventData={courseDetailsEventData}
    >
      {hasHeader
        ? <H3 inverted className={titleClass}>{courseTitle}</H3>
        : <div>{courseTitle}</div>
      }
    </Link>
  )
}

TitleCourseVideo.propTypes = {
  linkClass: PropTypes.string,
  titleClass: PropTypes.string,
  hasHeader: PropTypes.bool,
  video: ImmutablePropTypes.map,
  primaryCourse: ImmutablePropTypes.map,
}

export default compose(
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
      video: state.video,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(TitleCourseVideo)
